import setCssVar from '../utils/setCssVar';
import debounce from '../utils/debounce';

export default class SeeMore {
  constructor(elem, _) {
    this.elem = elem;
    this.items = this.elem.querySelectorAll('.js-see-more-item');
    this.padding = 35;
  }

  setTextWidthVariable(item) {
    const text = item.querySelector('.js-see-more-text');
    const width = text.offsetWidth;
    setCssVar(item, '--pill-width', `${width + this.padding}px`);
  }

  onResize() {
    // we need to reset the width of the items in order to recalculate the width of the text, set the width variable to 100% briefly and then back to the measured width
    this.items.forEach(item => {
      setCssVar(item, '--pill-width', '100%');
      setTimeout(() => {
        this.setTextWidthVariable(item);
      }, 100);
    });
  }

  init() {
    document.fonts.load('14px RundText').then(() => {
      this.items.forEach(item => this.setTextWidthVariable(item));
    });
    window.addEventListener('resize', debounce(this.onResize.bind(this), 100));
  }
};
